import { USER_AUTH } from '@/store/variables'

const hasPermission = {
  install (Vue, options) {
    Vue.directive('has', {
      inserted: (el, binding, vnode) => {
        console.time()
        filterGlobalPermission(el, binding, vnode)
        console.timeEnd() // 计时结束并输出时长
      },
      update: (el, binding, vnode) => {
        console.time()
        filterGlobalPermission(el, binding, vnode)
        console.timeEnd() // 计时结束并输出时长
      }
    })
  }
}

/**
 * 全局权限控制
 */
export function filterGlobalPermission (el, binding, vnode) {
  console.log('全局页面权限--Global--')
  vnode.context.$nextTick(() => {
    const authList = JSON.parse(sessionStorage.getItem(USER_AUTH) || '[]')
    if (authList === null || authList === '' || authList === undefined || authList.length <= 0) {
      el.remove()
      return
    }
    if (!authList.includes(binding.value)) {
      el.remove()
    }
  })
}

/**
 * 检查授权编码授权编码
 * @param authCode
 */
export function hasAuth (authCode) {
  const authList = JSON.parse(sessionStorage.getItem(USER_AUTH) || '[]')
  if (authList === null || authList === '' || authList === undefined || authList.length <= 0) {
    return false
  }

  if (authList.includes(authCode)) {
    return true
  }
  return false
}

export default hasPermission
